import React from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { Breadcrumbs, Stack, Typography } from '@mui/material';

const pageTitleIds: Record<string, string> = {
  '/scoremodel': 'ScoreModel',
  '/rules': 'Rules',
  '/variables': 'Variables',
  '/xml': 'Xml'
};

export const CompactHeaderBar = () => {
  const intl = useIntl();
  const { pathname } = useLocation();
  const section = Object.keys(pageTitleIds).find((p) => pathname.startsWith(p)) ?? '/scoremodel';

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        height: 40,
        px: 2.5,
        flexShrink: 0,
        bgcolor: 'background.paper',
        borderBottom: 1,
        borderColor: 'divider'
      }}>
      <Breadcrumbs>
        <Typography variant="body2" color="text.secondary">
          Score
        </Typography>
        <Typography variant="body2" fontWeight={600} color="text.primary">
          {intl.formatMessage({ id: pageTitleIds[section] })}
        </Typography>
      </Breadcrumbs>
    </Stack>
  );
};
